import { CAPABILITIES } from "../../data/site";

export default function Marquee() {
    const items = [...CAPABILITIES, ...CAPABILITIES];
    return (
        <section
            data-testid="capability-strip"
            aria-label="Capabilities"
            className="marquee-mask overflow-hidden bg-brand py-7"
        >
            <div className="flex w-max animate-marquee items-center gap-12 pr-12 hover:[animation-play-state:paused]">
                {items.map((cap, i) => (
                    <span key={i} className="flex items-center gap-12">
                        <span className="whitespace-nowrap font-mono text-sm font-semibold uppercase tracking-[0.3em] text-blue-100 transition-colors duration-300 hover:text-white">
                            {cap}
                        </span>
                        <span className="h-1.5 w-1.5 rotate-45 border border-white/50" aria-hidden="true" />
                    </span>
                ))}
            </div>
        </section>
    );
}
